import { create } from 'zustand';
import { Country } from '../types/Country';

interface CountryStore {
  country: Country | null;
  setCountry: (country: Country) => void;
}

export const useCountryStore = create<CountryStore>((set) => ({
  country: null,
  setCountry: (country: Country) => set({ country }),
}));
